'use client'
import styles from './PageStickyContact.module.scss'
import SVGPhone from '@/src/components/common/SVG/SVGPhone'
import PageGutter from '@/src/components/common/PageGutter'
import CTAButton from '@/src/components/common/CTAButton'
import useWindowScroll from '@/src/hooks/useWindowScroll'
import { useContext, useRef, useState } from 'react'
import usePageLoad from '@/src/hooks/usePageLoad'
import { DirectusContext } from '@/src/contexts/DirectusContext'
import useWindowSize from '@/src/hooks/useWindowSize'
import useTrackingNumber from '@/src/hooks/useTrackingNumber'

export default function PageStickyContactClient() {
  const ref = useRef<HTMLDivElement>(null)
  const [shown, setShown] = useState(false)
  const directusContext = useContext(DirectusContext)
  const siteSettings = directusContext.SITE_SETTINGS

  const handleWindowState = () => {
    const e = ref.current!

    const shouldShow =
      Math.floor(e.getBoundingClientRect().top) - Math.floor(window.innerHeight) >= -1

    if (shouldShow !== shown) {
      setShown(shouldShow)
    }
  }

  usePageLoad(() => {
    handleWindowState()
  })

  useWindowScroll(() => {
    handleWindowState()
  }, 0)

  useWindowSize(() => {
    handleWindowState()
  })

  const phone_num = siteSettings.phone_number
  if (!phone_num) {
    throw new Error('Phone number is not set in Site Settings')
  }

  const trackingNumber = useTrackingNumber(phone_num)

  return (
    <PageGutter ref={ref} className={styles.container}>
      <CTAButton
        style={{ opacity: shown ? 1 : 0 }}
        theme_color={'inverse'}
        className={styles.button}
        behavior={'phone_number'}
        text={
          <>
            <SVGPhone />
            <span>{trackingNumber}</span>
          </>
        }
        href={`tel:${trackingNumber.replace(/[^\d]/g, '')}`}
      />
    </PageGutter>
  )
}
